
import React, { useEffect, useState } from "react";
// import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import axios from "../../API/axios";
import usePagedOptions from "../../hooks/usePagedOptions";
// import { toast } from "react-hot-toast";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import CreatableSelect from "react-select/creatable";
import { useTranslation } from "react-i18next";

const CCVSkillUpdate = ({ resumeId, showSkills, handleUpdateSkillClose, getUserCcv, userUid, skillsData }) => {
    console.log('skillsData', skillsData);

    const [display, setDisplay] = useState(false);
    const [value, setValue] = useState(null);
    const [newCreateoption, setNewCreateoption] = useState("");
    const sessionId = localStorage.getItem("sessionId");
    const { t } = useTranslation();
   const language = localStorage.getItem("Lang");

    const fetchPage = async ({ typed, page }) => {
        if (!selectedOption?.value) return { items: [], totalPages: 0 };
        const res = await axios.get(
            `Master/GetSkillsByIndustryDDL?search=${typed || ""}&Fitid=${selectedOption?.value}&pageNumber=${page}&pageSize=100&LangKey=${language}&DeviceType=Web`
        );
        const data = res?.data?.responseData?.data || [];
        const items = data.map((item) => ({ value: item.skllId, label: item.name }));
        const totalPages = res?.data?.responseData?.paging?.totalPages || 1;
        return { items, totalPages };
    };

    const paged = usePagedOptions({ fetchPage, debounceMs: 300 });

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [errorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    const [selectedOption, setSelectedOption] = useState(null);
    const [industryList, setIndustryList] = useState([]);
    const [showIndustryInput, setShowIndustryInput] = useState(false);
    const [industryInputValue, setIndustryInputValue] = useState("");

    const getIndustry = () => {
        axios
            .get(`Master/GetFirmIndustryTypeDDL?LangKey=${language}`)
            .then((response) => {
                const res = response.data.responseData;
                const data = res.map((item) => ({
                    value: item.fitid,
                    label: item.name,
                }));
                setIndustryList(data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        getIndustry();
    }, []);

    const handleOpen = () => {
        paged.onMenuOpen();
    };

    const handleChange = (value) => {
        setValue(value);
        paged.reset();
        if (value?.label) {
            paged.onInputChange(value.label);
        }
    };

    const handleInputChange = (typed) => {
        paged.onInputChange(typed);
    };

    const handleMenuScrollToBottom = () => {
        paged.onMenuScrollToBottom();
    };

    useEffect(() => {
        if (skillsData) {
            setValue({ value: skillsData.skllId, label: skillsData.skillName });
            paged.onInputChange(skillsData.skillName);
            setSelectedOption(skillsData.fitid);
        }
    }, [skillsData]);

    const UpdateSkill = async () => {
        setDisplay(true);
        const postdatadetails = {
            deviceType: "Web",
            sessionId: sessionId,
            rsmId: resumeId,
            rsmSkllId: skillsData.skillId,
            fitid: selectedOption?.value,
            skillName: value.label,
            langKey: language === "en" ? "" : language,
            // newSkllId: value.value

        };

        try {
            await axios
                .post("ResumeData/UpdateRsmSkill", postdatadetails)
                .then((resData) => {
                    console.log('resData', resData);

                    setToastMessage(resData.data.message);
                    setShowToast(true);
                    handleUpdateSkillClose();
                    setSelectedOption(null);
                    setValue(null);
                    paged.reset();
                    getUserCcv()
                });
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }
    };

    useEffect(() => {
        if (skillsData.fitid) {
            const initialOption = industryList.find(option => option.value === skillsData.fitid);
            setSelectedOption(initialOption);
            if (initialOption) {
                setIndustryInputValue(initialOption.label);
                setShowIndustryInput(true);
            }
        }
    }, [skillsData, industryList]);

    const handleIndustryChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        paged.reset();
        if (selectedOption) {
            setIndustryInputValue(selectedOption.label);
            setShowIndustryInput(true);
        } else {
            setIndustryInputValue("");
            setShowIndustryInput(false);
        }
    };

    // useEffect(() => {
    //     if (showSkills) {
    //         document.body.style.overflow = 'hidden';
    //         document.documentElement.style.overflow = 'hidden';
    //         document.body.classList.add('modal-open'); // When a modal opens
    //     } else {
    //         document.body.style.overflow = 'unset';
    //         document.documentElement.style.overflow = '';
    //         document.body.classList.remove('modal-open'); // When a modal closes
    //     }
    // }, [showSkills]);

    useEffect(() => {
        // when industry filter changes, refetch with current typed
        if (selectedOption?.value) {
            paged.reset();
            if (value?.label) {
                paged.onInputChange(value.label);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOption?.value]);

    return (
        <>
            {showSkills && (
                <div
                    className="modal fade show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content d-flex justify-content-around p-2">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6>{t("User Profile.Update Skill")}</h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        handleUpdateSkillClose();
                                    }}
                                />
                            </div>
              <div className=" pb-4 settings p-2">
                            <div className="mb-4 ">
                                <label htmlFor="about">
                       {t ("User Profile.Industry")}    
                      <span className='text-danger ms-2'>*</span></label>
                                {showIndustryInput ? (
                                    <input
                                        type="text"
                                        className="Dark-Input-from-group form-control"
                                        value={industryInputValue}
                                        onChange={(e) => {
                                            setIndustryInputValue(e.target.value);
                                            setSelectedOption({ ...selectedOption, label: e.target.value });
                                        }}
                                        onBlur={() => {
                                            if (!industryInputValue.trim()) {
                                                setShowIndustryInput(false);
                                            }
                                        }}
                                        autoFocus
                                    />
                                ) : (
                                    <Select
                                        options={industryList}
                                        value={selectedOption}
                                        styles={customStyles}
                                        onChange={handleIndustryChange}
                                        placeholder={t("User Profile.Select industry")}
                                        className="dropdownBorder"
                                        isClearable
                                    />
                                )}
                                {display && !selectedOption ? (
                                    <span className="error_msg_lbl">{t("User Profile.Please Select industry")} </span>
                                ) : null}
                            </div>
                            <div>
                                 <label htmlFor="about">
                       {t ("User Profile.Skills")}    
                      <span className='text-danger ms-2'>*</span></label>
                                <CreatableSelect
                                    value={value}
                                    options={paged.options}
                                    onOpen={handleOpen}
                                    onChange={handleChange}
                                    onMenuScrollToBottom={handleMenuScrollToBottom}
                                    onInputChange={handleInputChange}
                                    className="dropdownBorder"
                                    isClearable
                                    placeholder={t("User Profile.Search and Select Skill")}
                                    invalid={display && value === ""}
                                    styles={customStyles}
                                />
                                {display && !value ? (
                                    <span className="error_msg_lbl">{t("User Profile.Please Select Skill")} </span>
                                ) : null}
                            </div>
                            </div>
                            <div className='mt-2 text-end'>
                                <button
                                    type="button"
                                    className="closebtn me-2"
                                    onClick={handleUpdateSkillClose}
                                    style={{ width: "70px" }}
                                >
                                    {t("User Profile.Close")}
                                </button>
                                <button
                                    type="button"
                                    className="mainBtn1"
                                    onClick={UpdateSkill}
                                    style={{ width: "107px" }}
                                >
                                    {t("Manage Job.Update")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />
            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />
            <ErrorToast
                show={showErrorToast}
                message={errorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    );
};

export default CCVSkillUpdate;
